import { socketEvents } from 'lib/socket';
import { useEffect } from 'react';

const useWebSocket = ( onChatUpdate, onMessageReceived, onMessageSend, onChatsReload, onMessagingHistorySet, onSubSessionUpdate, onMessageUpdate ) => {

	useEffect( () => {
		socketEvents.onChatUpdate( ( chat ) => {
			onChatUpdate( chat );
		} );

		socketEvents.onMessageReceived( ( message ) => {
			onMessageReceived( message );
		} );

		socketEvents.onMessageSend( ( message ) => {
			onMessageSend( message );
		} );

		socketEvents.onChatsReload( ( chat ) => {
			onChatsReload( chat );
		} );

		socketEvents.onMessagingHistorySet( ( history ) => {
			onMessagingHistorySet( history );
		} );

		socketEvents.onSubSessionUpdate( ( subSession ) => {
			onSubSessionUpdate( subSession );
		} );

		socketEvents.onMessageUpdate( ( data ) => {
			onMessageUpdate( data );
		} );

		// socketEvents.onChatUpdate( ( chat ) => {
		// 	console.log( 'onChatUpdate: ', chat );
		// } );
		// socketEvents.onChatUpdate2( ( chat ) => {
		// 	console.log( 'onChatUpdate2: ', chat );
		// } );

		return () => {
			socketEvents.offChatUpdate();
			socketEvents.offReceiveMessage();
			socketEvents.offChatsReload();
			socketEvents.offMessageSend();
			socketEvents.offMessagingHistorySet();
			socketEvents.offSubSessionUpdate();
			socketEvents.offMessageUpdate();
		};
	}, [] ); //eslint-disable-line
};

export default useWebSocket;